import { Link } from "react-router-dom";
import home_image from "../assets/home_image.png";
import Container from "../components/my-container/Container";

function HomePage() {
  return (
    <div className="bg-white h-fit min-h-screen flex items-center">
      <Container>
        <div className="mt-8 md:mt-0 mb-16 md:mb-0 max-w-[1100px] mx-auto grid grid-cols-1 md:grid-cols-2 gap-10 items-center">
          {/* Left Content */}
          <div>
            <h1 className="text-[min(7vw,55px)] font-extrabold text-gray-700 leading-tight tracking-tight">
              Impacting millions, one person at a time.
            </h1>
            <div className="mt-10 max-w-xs">
              <Link to="/login">
                <button className="w-full py-3 px-6 text-sm font-medium rounded-md bg-blue-600 text-white shadow-md hover:bg-blue-700 transition-all duration-300">
                  Get Started
                </button>
              </Link>
            </div>
          </div>

          {/* Right Image */}
          <div className="flex justify-center">
            <img
              src={home_image}
              alt="Delgro Introduction"
              className="w-full max-w-sm aspect-auto object-contain"
            />
          </div>
        </div>
      </Container>
    </div>
  );
}

export default HomePage;
